"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _find = _interopRequireDefault(require("lodash/find"));
var _values = _interopRequireDefault(require("lodash/values"));
var _get = _interopRequireDefault(require("lodash/get"));
var _uniqBy = _interopRequireDefault(require("lodash/uniqBy"));
var _size = _interopRequireDefault(require("lodash/size"));
var _styles = require("@material-ui/core/styles");
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));
var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));
var _Edit = _interopRequireDefault(require("@material-ui/icons/Edit"));
var _Delete = _interopRequireDefault(require("@material-ui/icons/Delete"));
var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));
var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _FormatPaint = _interopRequireDefault(require("@material-ui/icons/FormatPaint"));
var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));
var _withWidth = _interopRequireWildcard(require("@material-ui/core/withWidth"));
var _i18n = require("../../../../../Framework/i18n");
var _Selectors = require("../../../../Reducers/DesignArea/Selectors");
var _AnalyticsWrapper = _interopRequireDefault(require("../../../../Shared/Components/Analytics/AnalyticsWrapper"));
var _MessageBox = _interopRequireDefault(require("../../../../Shared/Components/MessageBox"));
var _getContrastText = _interopRequireDefault(require("../../../../Utils/getContrastText"));
var _ColorPalettes = _interopRequireDefault(require("../ColorPalettes"));
var _Select = _interopRequireDefault(require("../Select"));
var _clsx = _interopRequireDefault(require("clsx"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var styles = function styles(theme) {
  return {
    infoText: {
      fontStyle: 'italic',
      fontSize: 12,
      color: '#666'
    },
    maxColorError: {
      color: '#f00'
    },
    colorsContainer: _defineProperty({
      paddingLeft: 16,
      maxHeight: 144,
      overflowY: 'auto',
      marginTop: 15
    }, theme.breakpoints.down('xs'), {
      width: 'calc(100% - 18px)',
      paddingLeft: 0,
      marginBottom: 0,
      margin: 'auto'
    }),
    slider: {
      padding: '24px 0px'
    },
    gridGrow: {
      maxWidth: 150,
      flex: '1 1 100%'
    },
    colorBox: {
      width: 32,
      height: 32,
      background: 'red',
      borderRadius: '50%',
      borderColor: '#212121',
      boxShadow: '0px 0px 2px'
    },
    editButton: {
      cursor: 'pointer',
      color: theme.palette.primary.darkText,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-around'
    },
    deleteContainer: {
      minWidth: 32
    },
    deleteButton: {
      cursor: 'pointer'
    },
    editButtonDisabled: {
      cursor: 'default'
    },
    colorInput: {
      textAlign: 'center',
      color: theme.palette.primary.darkText,
      textTransform: 'capitalize',
      fontWeight: 'bold',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      fontSize: 15,
      cursor: 'pointer'
    },
    justifyGrid: _defineProperty({}, theme.breakpoints.down('xs'), {
      justifyContent: 'space-between'
    }),
    buttonContainer: _defineProperty({
      margin: '12px -12px',
      display: 'flex',
      justifyContent: 'space-between',
      '& > *': _defineProperty({
        margin: '0 12px',
        flexGrow: 1,
        flexBasis: 0,
        fontSize: '14px',
        textTransform: 'none',
        fontWeight: 'bold',
        minHeight: '60px',
        maxWidth: '50%',
        '& > div': {
          minHeight: '60px'
        }
      }, theme.breakpoints.down('xs'), {
        margin: 0
      })
    }, theme.breakpoints.down('xs'), {
      display: 'flex',
      margin: '24px 0px',
      '& > *:first-child': {
        maxWidth: '190px'
      },
      '& button': {
        marginLeft: 12
      }
    }),
    resetButtonText: {
      textTransform: 'none',
      fontWeight: 'bold'
    },
    vectorsNotRequired: {
      marginTop: 10,
      textTransform: 'none'
    },
    listItemText: _defineProperty({
      fontSize: '12px',
      lineHeight: '40px'
    }, theme.breakpoints.down('xs'), {
      lineHeight: '56px'
    })
  };
};
var ImageColorize = /*#__PURE__*/function (_React$Component) {
  _inherits(ImageColorize, _React$Component);
  var _super = _createSuper(ImageColorize);
  function ImageColorize() {
    var _this;
    _classCallCheck(this, ImageColorize);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      selectedColor: null,
      selectedColorPalette: null,
      vectorizeThreshold: 0,
      isThresholdSliderDisabled: false,
      designProductionMethodName: '',
      vectorizeRequested: false
    });
    _defineProperty(_assertThisInitialized(_this), "onVectorizeThresholdChange", function (event) {
      var onVectorizeThresholdChange = _this.props.onVectorizeThresholdChange;
      var thresholdValue = event.target.value;
      _this.setState({
        prevThreshold: thresholdValue,
        vectorizeThreshold: thresholdValue
      });
      onVectorizeThresholdChange && onVectorizeThresholdChange(thresholdValue);
    });
    _defineProperty(_assertThisInitialized(_this), "onColorSelectClick", function (value, identifier, paletteIdentifier, custom) {
      var onColorSelectClick = _this.props.onColorSelectClick;
      var colorKey = _this.state.selectedColor;
      _this.setState({
        selectedColor: null
      });
      var createdColor = (0, _Selectors.createColorData)(identifier, paletteIdentifier, custom, '#' + value);
      onColorSelectClick && onColorSelectClick(colorKey, createdColor);
    });
    _defineProperty(_assertThisInitialized(_this), "onColorPaletteClose", function () {
      _this.setState({
        selectedColor: null
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onEditClick", function (colorKey) {
      _this.setState({
        selectedColor: colorKey
      });
    });
    _defineProperty(_assertThisInitialized(_this), "resetImageState", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var onColorImageStateReset;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            onColorImageStateReset = _this.props.onColorImageStateReset;
            _context.t0 = onColorImageStateReset;
            if (!_context.t0) {
              _context.next = 5;
              break;
            }
            _context.next = 5;
            return onColorImageStateReset();
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    _defineProperty(_assertThisInitialized(_this), "getColorName", function (color) {
      var colorPalettes = _this.props.colorPalettes;
      var data = (0, _Selectors.parseColorData)(color.identifier);
      if (!(0, _Selectors.isValidHex)(color.value)) {
        return data.color + " (".concat((0, _i18n.t)('imageEditDialog.customColor'), ")");
      }
      var colorPalette = (0, _find["default"])(colorPalettes, {
        identifier: data.palette
      });
      if (!colorPalette) {
        return data.color.toUpperCase();
      }
      var paletteColor = (0, _find["default"])(colorPalette.colors, {
        identifier: data.color
      });
      if (!paletteColor) {
        return data.color.toUpperCase();
      }
      return paletteColor.title;
    });
    _defineProperty(_assertThisInitialized(_this), "getColorValue", function (color) {
      var value = color.value;
      return (0, _Selectors.isValidHex)(value) ? value : '#000000';
    });
    _defineProperty(_assertThisInitialized(_this), "onVectorizeToggleChange", function (e, value) {
      var onVectorizeToggleChange = _this.props.onVectorizeToggleChange;
      _this.setState({
        vectorizeRequested: value
      });
      onVectorizeToggleChange && onVectorizeToggleChange(value);
    });
    _defineProperty(_assertThisInitialized(_this), "validateAmount", function () {
      var _this$props = _this.props,
        maxColorAmount = _this$props.maxColorAmount,
        colorAmount = _this$props.colorAmount;
      return !maxColorAmount || colorAmount <= maxColorAmount;
    });
    _defineProperty(_assertThisInitialized(_this), "getSelectedColorPalette", function (color) {
      var colorPalettes = _this.props.colorPalettes;
      var selectedColorPalette = _this.state.selectedColorPalette;
      var colorData = (0, _Selectors.parseColorData)(color.identifier);
      var colorPalette = (0, _find["default"])(colorPalettes, {
        identifier: selectedColorPalette || colorData.palette
      });
      return colorPalette || colorPalettes[0];
    });
    _defineProperty(_assertThisInitialized(_this), "getColorAmountMessage", function () {
      var _this$props2 = _this.props,
        colorAmount = _this$props2.colorAmount,
        maxColorAmount = _this$props2.maxColorAmount;
      if (!maxColorAmount) {
        return (0, _i18n.t)('colorAmountIndicator.unlimitedColors');
      }
      if (colorAmount > maxColorAmount) {
        return (0, _i18n.t)('colorAmountIndicator.warning', {
          colorAmount: colorAmount,
          maxColorAmount: maxColorAmount
        });
      }
      return (0, _i18n.t)('colorAmountIndicator.ok', {
        colorAmount: colorAmount
      });
    });
    _defineProperty(_assertThisInitialized(_this), "getColors", function (vectorizeColorsMap, colorPalettes) {
      var usedColors = _this.props.usedColors;
      try {
        var imageColors = (0, _values["default"])(vectorizeColorsMap);
        var usedImageColors = [];
        imageColors.forEach(function (color) {
          var identifier = (0, _get["default"])(color, 'identifier');
          var parsedColor = JSON.parse(identifier);
          if (!parsedColor.custom) {
            var colorPalette = (0, _find["default"])(colorPalettes, {
              identifier: parsedColor.palette
            }) || {};
            var colors = (0, _find["default"])(colorPalette.colors, {
              identifier: parsedColor.color
            });
            usedImageColors.push(_objectSpread(_objectSpread({}, colors), {}, {
              value: color.value,
              palette: colorPalette.identifier
            }));
          }
        });
        return (0, _uniqBy["default"])([].concat(usedImageColors, usedColors), 'identifier');
      } catch (_unused) {
        // eslint-disable-next-line no-console
        console.error('failed to parse color data');
        return null;
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onColorPaletteChange", function (identifier) {
      _this.setState({
        selectedColorPalette: identifier
      });
    });
    return _this;
  }
  _createClass(ImageColorize, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var vectorizeThreshold = this.props.vectorizeThreshold;
      this.setState({
        vectorizeThreshold: vectorizeThreshold
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props3 = this.props,
        vectorizeThreshold = _this$props3.vectorizeThreshold,
        vectorizeColorsMap = _this$props3.vectorizeColorsMap;
      if (vectorizeThreshold !== prevProps.vectorizeThreshold || (0, _size["default"])(vectorizeColorsMap) !== (0, _size["default"])(prevProps.vectorizeColorsMap)) {
        this.setState({
          vectorizeThreshold: vectorizeThreshold
        });
      }
    }
  }, {
    key: "renderColorizeTools",
    value: function renderColorizeTools() {
      var _this2 = this;
      var _this$props4 = this.props,
        classes = _this$props4.classes,
        colorPalettes = _this$props4.colorPalettes,
        vectorizeColorsMap = _this$props4.vectorizeColorsMap,
        disableInputs = _this$props4.disableInputs,
        width = _this$props4.width,
        vectorize = _this$props4.vectorize,
        inputRef = _this$props4.inputRef,
        aggregatedColors = _this$props4.aggregatedColors,
        isLoading = _this$props4.isLoading,
        imageColorsWereEdited = _this$props4.imageColorsWereEdited,
        colorAmountList = _this$props4.colorAmountList,
        customControlElements = _this$props4.customControlElements;
      var _this$state = this.state,
        selectedColor = _this$state.selectedColor,
        vectorizeThreshold = _this$state.vectorizeThreshold,
        vectorizeRequested = _this$state.vectorizeRequested;
      var onColorRemoveClick = this.props.onColorRemoveClick;
      var thresholdValue = colorAmountList.indexOf(vectorizeThreshold) === -1 ? 0 : vectorizeThreshold;
      var amountIsValid = this.validateAmount();
      var aggregatedColorKeys = Object.keys(aggregatedColors);
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, customControlElements, /*#__PURE__*/_react["default"].createElement(_MessageBox["default"], {
        ref: inputRef,
        type: amountIsValid ? 'success' : 'error',
        text: this.getColorAmountMessage()
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: classes.buttonContainer
      }, /*#__PURE__*/_react["default"].createElement(_AnalyticsWrapper["default"], {
        targetId: "image_edit_colorize_found_colors"
      }, /*#__PURE__*/_react["default"].createElement(_Select["default"], {
        bold: true,
        value: thresholdValue,
        onChange: this.onVectorizeThresholdChange,
        readOnly: false,
        iconClass: '',
        disabled: disableInputs,
        error: !isLoading && !thresholdValue
      }, /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
        disabled: true,
        value: 0
      }, ' ', /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
        className: classes.listItemText,
        noWrap: true
      }, (0, _i18n.t)('imageEditDialog.changeColorAmount'))), colorAmountList.map(function (colorAmount) {
        return /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
          key: colorAmount,
          value: colorAmount
        }, ' ', /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
          className: classes.listItemText,
          noWrap: true
        }, colorAmount === 1 ? (0, _i18n.t)('imageEditDialog.imageColor', {
          amount: colorAmount
        }) : (0, _i18n.t)('imageEditDialog.imageColors', {
          amount: colorAmount
        })));
      }))), (imageColorsWereEdited || vectorizeRequested) && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        variant: "outlined",
        onClick: this.resetImageState,
        disabled: isLoading,
        startIcon: /*#__PURE__*/_react["default"].createElement(_Delete["default"], null)
      }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
        className: classes.resetButtonText
      }, (0, _i18n.t)('imageEditDialog.resetButton')))), vectorize && /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true,
        spacing: 2,
        className: classes.colorsContainer
      }, aggregatedColorKeys.map(function (colorKey) {
        var background = _this2.getColorValue(vectorizeColorsMap[colorKey]);
        return /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
          item: true,
          key: colorKey,
          sm: 6,
          xs: 12
        }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
          container: true,
          spacing: 1,
          alignItems: "flex-end",
          wrap: "nowrap",
          className: classes.justifyGrid
        }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
          item: true
        }, /*#__PURE__*/_react["default"].createElement(_AnalyticsWrapper["default"], {
          targetId: "image_colorize",
          data: colorKey
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: (0, _clsx["default"])(classes.colorBox, classes.editButton, disableInputs && classes.editButtonDisabled),
          style: {
            background: background
          },
          onClick: function onClick() {
            return !disableInputs && _this2.onEditClick(colorKey);
          }
        }, /*#__PURE__*/_react["default"].createElement(_Edit["default"], {
          style: {
            color: (0, _getContrastText["default"])(background)
          }
        })))), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
          item: true,
          className: classes.gridGrow
        }, /*#__PURE__*/_react["default"].createElement(_TextField["default"], {
          disabled: true,
          fullWidth: true,
          onClick: function onClick() {
            return !disableInputs && _this2.onEditClick(colorKey);
          },
          value: _this2.getColorName(vectorizeColorsMap[colorKey]),
          InputProps: {
            disableUnderline: true
          },
          inputProps: {
            className: classes.colorInput
          }
        })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
          item: true,
          className: classes.deleteContainer
        }, aggregatedColorKeys.length > 1 && /*#__PURE__*/_react["default"].createElement(_Close["default"], {
          disabled: true,
          className: (0, _clsx["default"])(classes.deleteButton, disableInputs && classes.editButtonDisabled),
          onClick: function onClick() {
            return !disableInputs && onColorRemoveClick(colorKey);
          }
        }))));
      }, this)), colorPalettes && colorPalettes.length > 0 && selectedColor && /*#__PURE__*/_react["default"].createElement(_Dialog["default"], {
        open: selectedColor !== null,
        maxWidth: "xs",
        fullWidth: true,
        fullScreen: (0, _withWidth.isWidthDown)('xs', width),
        onClose: this.onColorPaletteClose
      }, /*#__PURE__*/_react["default"].createElement(_ColorPalettes["default"], {
        selectedColor: vectorizeColorsMap[selectedColor],
        colorSelectClick: this.onColorSelectClick,
        colorPalettes: colorPalettes,
        usedColors: this.getColors(vectorizeColorsMap, colorPalettes),
        palette: this.getSelectedColorPalette(vectorizeColorsMap[selectedColor]),
        closeColorPalettes: this.onColorPaletteClose,
        colorPaletteChange: this.onColorPaletteChange
      })));
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props5 = this.props,
        classes = _this$props5.classes,
        vectorize = _this$props5.vectorize,
        designProductionMethodName = _this$props5.designProductionMethodName;
      return vectorize ? this.renderColorizeTools() : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
        variant: "body1",
        component: "div"
      }, (0, _i18n.T)('imageEditDialog.imageWithoutVectorization', {
        designProductionMethodName: designProductionMethodName
      })), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        variant: "outlined",
        startIcon: /*#__PURE__*/_react["default"].createElement(_FormatPaint["default"], null),
        className: classes.vectorsNotRequired,
        onClick: function onClick(e) {
          return _this3.onVectorizeToggleChange(e, true);
        }
      }, (0, _i18n.t)('imageEditDialog.editColors')));
    }
  }]);
  return ImageColorize;
}(_react["default"].Component);
var _default = exports["default"] = (0, _styles.withStyles)(styles, {
  name: 'ImageColorize'
})((0, _withWidth["default"])({
  initialWidth: 'lg'
})(ImageColorize));